import React from 'react';
import { Link } from 'react-router-dom';

const InfoCard = ({
    imageUrl,
    imageAlt = "Information",
    title,
    linkTo,
    linkText = "Ver más",
    colClasses = "col-md-3 mb-3", // Default column classes
    cardClasses = "card card-service border-0", // Default card classes, added base 'card'
    buttonClasses = "btn btn-checkin py-1 px-2" // Default button classes
}) => {
    return (
        <div className={colClasses}>
            <div className={cardClasses}>
                <img src={imageUrl} className="card-img-top" alt={imageAlt} />
                <div className="card-body p-3">
                    <h5 className="card-title">{title}</h5>
                    {linkTo && (
                        <Link to={linkTo} className={buttonClasses}>
                            {linkText}
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default InfoCard;